<template>
	<div class="sub-box">
		<a v-on:click="toggleSubscribe" href="#" class="subscribe__toggle" v-show="getEarlyAccessVisible" id="toggle">Learn More</a>
		<span class="subscribe__success" v-show="successVisible">You're all set 🎉</span>
		<div class="subscribe__wrapper" v-show="emailIDVisible">
			<input v-model="emailAddress" type="text" placeholder="email address"/>
			<button v-on:click="submitEmail" id="submit">join</button>
		</div>
	</div>
</template>

<script>
import db from '../services/firestoreInit'

export default {
	name: "SignUp",
	data: function () {
		return {
			emailAddress: "",
			getEarlyAccessVisible: true,
			emailIDVisible: false,
			successVisible: false
		}
	},
	methods: {
		verifyEmail: function (emailID) {
			var re = /\S+@\S+\.\S+/;
			return re.test(emailID);
		},
		toggleSubscribe: function () {
			this.getEarlyAccessVisible = false;
			this.emailIDVisible = true;
		},
		submitEmail: function () {
			var content = document.querySelectorAll('.subscribe__wrapper');

			const isValidEmail = this.verifyEmail(this.emailAddress);

			if (isValidEmail) {
				this.emailIDVisible = false;
				this.successVisible = true;

				// FIXME: Uncomment on deployment + remove log
				db.collection("StaytionSubscriptions").add({
					email: this.emailAddress
				})
			} else {
				content[0].classList.add("shake");
			}

			setTimeout(function(){
				if (content[0].classList.contains("shake")){
					content[0].classList.remove("shake");
				}
			}, 2000);
		}
	},
	mounted() {
		var content = document.querySelectorAll('.subscribe__wrapper');
		content[0].style.display = 'none';
	},
};
</script>

<style scoped>

.sub-box {
	font-weight: bold ;
	text-align: center;
	border-radius: 4px;
}

.subscribe__active {
	margin: auto;
	border-radius: 5px;
}

.subscribe__toggle {
	background: #fff;
	color: #1A2534;
	font-size: calc(12px + 0.5vw);
	text-decoration: none;
	padding: 5px 10px 5px 10px;
	border-radius: 10px;
}

.subscribe__wrapper {
	display: inline-block;
	background-color: #fff;
	padding: 0px 3px 0px 1px;
	border-radius: 4px;
}

.subscribe__wrapper input[type="text"] {
	color: white;
	background: rgb(26, 37, 52);
	border: 0;
	margin: 1px;
	border-radius: 4px;
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
	font-size: calc(12px + 0.5vw);
	font-family: inherit;
	outline: 0;
	padding: 5px 8px 5px 8px;
	box-sizing: border-box;
}

input::placeholder {
	color:  #fff;
}


.subscribe__wrapper button {
	border: 0;
	background: transparent;
	font-size: calc(12px + 0.5vw);
	color: #fff;
	font-family: inherit;
	font-weight: bold;
	color: rgb(26, 37, 52);
	padding-left: 5px;
}

.subscribe__wrapper button:hover {
	cursor: pointer;
}

.subscribe__success {
	font-size: calc(12px + 0.5vw);
	padding: 3px 8px 3px 8px;
	border-radius: 8px;
	border: 2px;
	border-color: #fff;
	border-style: solid;
	color: #fff;
}

@-webkit-keyframes spaceboots {
	0% { -webkit-transform: translate(2px, 0px) rotate(0deg); }
	10% { -webkit-transform: translate(6px, 0px) rotate(0deg); }
	20% { -webkit-transform: translate(12px, 0px) rotate(0deg) }
	30% { -webkit-transform: translate(6px, 0px) rotate(0deg); }
	40% { -webkit-transform: translate(2px, 0px) rotate(0deg) }
	50% { -webkit-transform: translate(-2px, 0px) rotate(0deg) }
	60% { -webkit-transform: translate(-6px, 0px) rotate(0deg); }
	70% { -webkit-transform: translate(-12px, 0px) rotate(0deg) }
	80% { -webkit-transform: translate(-6px, 0px) rotate(0deg) }
	90% { -webkit-transform: translate(-2px, 0px) rotate(0deg); }
	100% { -webkit-transform: translate(2px, 0px) rotate(0deg) }
}
.shake {
	-webkit-animation-name: spaceboots;
	-webkit-animation-duration: 0.2s;
	-webkit-transform-origin: 50% 50%;
	-webkit-animation-iteration-count: 2;
	-webkit-animation-timing-function: linear;
}

</style>